require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./photos-professional-z-8-goo.json") })
        }
      }, "path---photos-professional-z-8-goo");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---photos-professional-z-8-goo!./.cache/json/photos-professional-z-8-goo.json
// module id = 1132
// module chunks = 231608221292675